export const transformFilterValues = (values: Record<string, unknown>) => {
    const transformedValues = { ...values };

    Object.keys(values).forEach((key) => {
        const value = values[key];
        if ((Array.isArray(value) && value.length === 0) || value === '') {
            transformedValues[key] = undefined;
        }
    });

    return transformedValues;
};
